/* eslint-disable no-unreachable */
import React, { useEffect, useState, useContext } from "react";

// import Chart from "../../../../components/accounting/charts/chart/Chart";
import ReportsSummaryTable from "./ReportsSummaryTable";
import SchoolWiseReportsTable from "./SchoolWiseReportsTable";

import { StoreContext } from "shared/context/store-context";

import { computeMonthlyData } from "shared/utility/reports";

const ReportsSummary = () => {
  const {
    studentSchools,
    contracts,
    expenses,
    receipts,
    withdraws,
    educationYears,
    students,
    selectedEducationYearId,
  } = useContext(StoreContext);

  const [reportCreated, setReportCreated] = useState(false);
  const [report, setReport] = useState(null);
  const [currentEducationYear, setCurrentEducationYear] = useState(null);

  useEffect(() => {
    const currentYear = educationYears.find((year) => year.id.toString() === selectedEducationYearId.toString());
    setCurrentEducationYear(currentYear);
    const schoolReportData = computeMonthlyData({
      contracts,
      schools: studentSchools,
      receipts,
      expenses,
      withdraws,
      currentEducationYear: currentYear,
    });
    setReport(schoolReportData);

    setReportCreated(true);
  }, [receipts, expenses, withdraws, contracts, students, selectedEducationYearId]);

  return (
    <React.Fragment>
      {reportCreated && (
        <div>
          <ReportsSummaryTable
            contractsAmount={report.totalContractsAmount}
            receiptsAmount={report.totalReceiptsAmount}
            withdrawsAmount={report.totalWithdrawsAmount}
            expensesAmount={report.totalExpensesAmount}
            currentEducationYear={currentEducationYear}
          />
          {studentSchools?.length > 1 && (
            <SchoolWiseReportsTable schools={report.schools} currentEducationYear={currentEducationYear} />
          )}

          {/* <Chart data={report.schools[0].receipts.months} title="Aylara Göre Gelirler" grid dataKey="amount" /> */}
        </div>
      )}
    </React.Fragment>
  );
};

export default ReportsSummary;
